// eslint-disable-next-line no-undef, jsdoc/require-returns
/**
 * Sorting Function.
 * @param data -Data.
 */
export default function sortDataByDate(data: Record<string, number>): Record<string, number> {
  const dates = Object.keys(data);
  dates.sort((a, b) => a.localeCompare(b));
  const sortedData: Record<string, number> = {};
  dates.forEach((date) => {
    sortedData[date] = data[date];
  });

  return sortedData;
}
